<div class="contact-us-wrapper container-fluid bg-lightblue ps-0 py-5 py-lg-0">
    <div class="container-xxxl ps-4 ps-xl-0">
        <div class="contact-us-layout ps-0 ms-0 pe-lg-5 py-2 py-lg-5 fs-md-18 pt-md-0">
            <div class="contact-image-wrap">
                <img class="contact-image w-100 d-print-none" [src]="image" [alt]="imageAlt" />
            </div>

            <div class="row d-flex justify-content-between info-box">
                <div class="col-12 col-lg-3 ps-0"></div>
                <div class="col-12 col-lg-8 col-xl-7">
                    <div class="contact-card p-4 p-lg-5 border border-blue bg-white shadow">
                        <h2 class="text-blue border-start border-blue border-5 ps-4 mb-4 lh-sm">{{ titleKa.title }}</h2>
                        <p [innerHTML]="titleKa.bodyText"></p>
                        <h3 class="h5 text-blue mb-4 fs-22 fw-bold">{{ formKa.title }}</h3>
                        <p [innerHTML]="formKa.bodyText"></p>
                        <a link class="btn btn-green btn-arrow text-white blue-effect" [href]="buttonUrl" target="_blank" rel="noopener"
                            >{{ buttonKa.title }} <i class="icon-gard-arrow-right ms-1"></i
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
